import React, { Component } from 'react';
import { Glyphicon, Table, Grid, Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { getPhasingFilesByPhasingProgramAttachmentIdAsImage, getDownloadFilesByPhasingStepIdURL, getCSVPhasingFilesByPhasingAttachmentIdURL, downloadPhasingFilesByPhasingAttachmentId } from '../../../../api/ispyb.js';
import _ from 'lodash';
import '../../../Mx/DataCollectionGroup/DataCollectionGroupPanel.css';
import ImageZoom from 'react-medium-image-zoom';
import { convertToFixed } from '../../../../helpers/NumericTransformationsHelper.js';
export default class PhasingDataCollectionGroup extends Component {

    render() {
        let data = [];
        if (this.props.fetching) {
            return "Fetching"
        }
        if (this.props.phasing[0]) {
            if (this.props.phasing[0].length > 0) {
                data = this.parse(this.props.phasing, 'SAD');
            }
        }
        console.log(data);
        return <div>
            {
                data.map((value, index) => {
                    return <PhasingResult result={value}></PhasingResult>

                })}
        </div>

    }



    parse(data, PhasingStep_method) {

        var _this = this;


        /** It filters all phasing step which method is _this.PhasingStep_method: [SAD | MR]  */
        data[0] = _.filter(data[0], { PhasingStep_method: PhasingStep_method })

        /** It gets all space groups */
        var spaceGroups = _.keyBy(data[0], "SpaceGroup_spaceGroupShortName");

        var parsed = [];

        /** Loop by space group in order to make a summary */
        for (var spaceGroup in spaceGroups) {
            if (spaceGroup != "null") {

                /** It gets all steps for the same space group */
                var stepsBySpaceGroup = _.filter(data[0], { "SpaceGroup_spaceGroupShortName": spaceGroup });

                function getStepId(stepsBySpaceGroup) {
                    return _.keys(_.keyBy(stepsBySpaceGroup, "PhasingStep_phasingStepId")).toString();
                }

                function getCSV(stepsBySpaceGroup) {
                    var keys = _.keys(_.keyBy(stepsBySpaceGroup, "csv"));
                    return _.filter(keys, function (e) { return e != "null"; });
                }

                /** node contains all steps for the same space group organized by step type */
                var node = {};

                /** Node to be displayed for MR. It has got two steps: [PHASING, REFINEMENT]*/
                if (_this.PhasingStep_method == "MR") {
                    node = ({
                        spaceGroup: spaceGroup,
                        hasPhasing: _.find(stepsBySpaceGroup, { "PhasingStep_phasingStepType": "PHASING" }) != null,
                        hasRefinement: _.find(stepsBySpaceGroup, { "PhasingStep_phasingStepType": "REFINEMENT" }) != null,
                        downloadCSV: getCSVPhasingFilesByPhasingAttachmentIdURL(getCSV(_this.props.user, _this.props.proposal, stepsBySpaceGroup)),
                        downloadFilesUrl: getDownloadFilesByPhasingStepIdURL(_this.props.user, _this.props.proposal, getStepId(stepsBySpaceGroup)),
                        steps: _.keysIn(_.keyBy(stepsBySpaceGroup, "PhasingStep_phasingStepType"))

                    });

                }
                else {
                    /** Node to be displayed for Phasing that contains several steps: [PREPARE, SUBSTRUCTUREDETERMINATION, PHASING, MODELBUILDING] */
                    node = ({
                        spaceGroup: spaceGroup,
                        hasPrepare: _.find(stepsBySpaceGroup, { "PhasingStep_phasingStepType": "PREPARE" }) != null,
                        hasSub: _.find(stepsBySpaceGroup, { "PhasingStep_phasingStepType": "SUBSTRUCTUREDETERMINATION" }) != null,
                        hasPhasing: _.find(stepsBySpaceGroup, { "PhasingStep_phasingStepType": "PHASING" }) != null,
                        hasModel: _.find(stepsBySpaceGroup, { "PhasingStep_phasingStepType": "MODELBUILDING" }) != null,
                        downloadCSV: getCSVPhasingFilesByPhasingAttachmentIdURL(_this.props.user, _this.props.proposal, getCSV(stepsBySpaceGroup)),
                        downloadFilesUrl: getDownloadFilesByPhasingStepIdURL(_this.props.user, _this.props.proposal, getStepId(stepsBySpaceGroup)),
                        steps: _.keysIn(_.keyBy(stepsBySpaceGroup, "PhasingStep_phasingStepType"))

                    });
                }


                /**
                 * This function adds the metrics into the dictionary and also the PNG
                 */
                function getMetrics(phasingStep) {
                    if (phasingStep.metric) {
                        var singleMetric = phasingStep.metric.split(",");
                        var values = phasingStep.statisticsValue.split(",");
                        for (var j = 0; j < singleMetric.length; j++) {
                            /* Spaces are replaced by _ to be used on the templates */
                            phasingStep[singleMetric[j].trim().replace(/ /g, '_')] = values[j];
                        }
                    }
                    if (phasingStep.png) {
                        /** It might happens that there are two PDB like:"159386,159388" */
                        var phasingStepPngs = phasingStep.png.split(",");
                        var fileTypes = phasingStep.fileType.split(",");
                        for (var z = 0; z < fileTypes.length; z++) {
                            /** Exclude other file types than IMAGE */
                            if (fileTypes[z] == "IMAGE") {
                                phasingStep.pngURL = getPhasingFilesByPhasingProgramAttachmentIdAsImage(_this.props.user, _this.props.proposal, phasingStepPngs[z]);
                            }
                        }
                    }
                    phasingStep.spaceGroup = phasingStep.SpaceGroup_spaceGroupShortName;
                    return (phasingStep);
                }


                /**
                 * This functions add to toBepush the URL for every fileType found
                     fileTypesField = CCALL_CCWEAK,OCCUPANCY_SITENUMBER
                     phasingProgramAttachmentFields = XXXX, YYYYY
                 */
                function parseFilteTypes(fileTypesField, phasingProgramAttachmentFields, toBePushed) {
                    if (fileTypesField != null) {
                        var types = fileTypesField.split(",");
                        var ids = phasingProgramAttachmentFields.split(",");
                        for (var r = 0; r < types.length; r++) {
                            toBePushed[types[r]] = getPhasingFilesByPhasingProgramAttachmentIdAsImage(_this.props.user, _this.props.proposal, ids[r]);
                        }
                    }
                }

                function parseDownloadAttachments(leaf) {
                    var fileAttachmentsId = [];
                    while (leaf != null) {
                        fileAttachmentsId.push(leaf.PhasingStep_phasingStepId);
                        leaf = _.find(stepsBySpaceGroup, { 'PhasingStep_phasingStepId': leaf.PhasingStep_previousPhasingStepId });
                    }
                    return fileAttachmentsId;
                }

                function getNodeByPhasingStep(node, stepsBySpaceGroup, step) {
                    var steps = _.filter(stepsBySpaceGroup, { "PhasingStep_phasingStepType": step });
                    node["metrics"] = [];
                    if (steps) {

                        for (var z = 0; z < steps.length; z++) {
                            var toBePushed = steps[z];
                            var listUglyMol = [];
                            /**
                             * This adds the phasing plots into the dictionary looking for them from the previous steps
                             */
                            var leaf = steps[z];
                            while (leaf != null) {
                                parseFilteTypes(leaf.fileType, leaf.phasingProgramAttachmentId, toBePushed);
                                leaf = _.find(stepsBySpaceGroup, { 'PhasingStep_phasingStepId': leaf.PhasingStep_previousPhasingStepId });
                            }

                            if (steps[z].metric) {
                                toBePushed = getMetrics(steps[z]);
                            }
                            if (step == "MODELBUILDING") {
                                /* Opening uglymol with:
                                        1) pdb file
                                        2) map1 as first map file
                                        3) map2 as second map file
                                        */
                                var pdbUrl = downloadPhasingFilesByPhasingAttachmentId(_this.props.user, _this.props.proposal, steps[z].pdb);
                                if (steps[z].map != null) {
                                    var mapsArr = steps[z].map.split(",");
                                    if (mapsArr.length == 2) {
                                        var mapUrl1 = downloadPhasingFilesByPhasingAttachmentId(_this.props.user, _this.props.proposal, mapsArr[0]);
                                        var mapUrl2 = downloadPhasingFilesByPhasingAttachmentId(_this.props.user, _this.props.proposal, mapsArr[1]);
                                        toBePushed["uglymol"] = '../viewer/uglymol/index.html?pdb=' + pdbUrl + '&map1=' + mapUrl1 + '&map2=' + mapUrl2;
                                    }
                                }
                            } else if (step == "REFINEMENT") {
                                var refinedPdbFileId = -1;
                                var mrPdbFileId = -1;
                                var peaksFileId = -1;
                                var blobFileId = -1;
                                if (steps[z].map != null) {
                                    var mapsArr = steps[z].map.split(",");
                                } else {
                                    var mapsArr = [];
                                }
                                if (steps[z].pdb != null) {
                                    var pdbsArr = steps[z].pdb.split(",");
                                } else {
                                    var pdbsArr = [];
                                }
                                if (steps[z].csv != null) {
                                    var csvsArr = steps[z].csv.split(",");
                                } else {
                                    var csvsArr = [];
                                }
                                if ("mapFileName" in steps[z]) {
                                    var mapFileNamesArr = steps[z].mapFileName.split(",");
                                    for (var i = 0; i < mapFileNamesArr.length; i++) {
                                        mapFileNamesArr[i] = mapFileNamesArr[i].slice(0, -4)
                                    }
                                } else {
                                    var mapFileNamesArr = [];
                                }
                                if ("pdbFileName" in steps[z]) {
                                    var pdbFileNamesArr = steps[z].pdbFileName.split(",");
                                    for (var i = 0; i < pdbFileNamesArr.length; i++) {
                                        if (pdbFileNamesArr[i] == "refined.pdb") {
                                            refinedPdbFileId = pdbsArr[i];
                                        } else if (pdbFileNamesArr[i] == "MR.pdb") {
                                            mrPdbFileId = pdbsArr[i];
                                        }
                                    }
                                } else {
                                    var pdbFileNamesArr = [];
                                }
                                if ("csvFileName" in steps[z] && steps[z].csvFileName != null) {
                                    var csvFileNamesArr = steps[z].csvFileName.split(",");
                                    for (var i = 0; i < csvFileNamesArr.length; i++) {
                                        if (csvFileNamesArr[i] == "peaks.csv") {
                                            peaksFileId = csvsArr[i];
                                        } else if (pdbFileNamesArr[i] == "blobs.csv") {
                                            blobFileId = csvsArr[i];
                                        }
                                    }
                                } else {
                                    var csvFileNamesArr = [];
                                }
                                if (mrPdbFileId != -1) {
                                    let index2FOFC_MR = mapFileNamesArr.indexOf("2FOFC_MR");
                                    let indexFOFC_MR = mapFileNamesArr.indexOf("FOFC_MR");
                                    if ((index2FOFC_MR == -1) || (indexFOFC_MR) == -1) {
                                        listUglyMol.push("");
                                    } else {
                                        var pdbUrl = downloadPhasingFilesByPhasingAttachmentId(this.props.user, this.props.proposal, mrPdbFileId);
                                        var mapUrl1 = downloadPhasingFilesByPhasingAttachmentId(this.props.user, this.props.proposal, mapsArr[index2FOFC_MR]);
                                        var mapUrl2 = downloadPhasingFilesByPhasingAttachmentId(this.props.user, this.props.proposal, mapsArr[indexFOFC_MR]);
                                        var peaks = downloadPhasingFilesByPhasingAttachmentId(this.props.user, this.props.proposal, peaksFileId);
                                        listUglyMol.push('../viewer/uglymol/index.html?pdb=' + pdbUrl + '&map1=' + mapUrl1 + '&map2=' + mapUrl2 + '&peaks=' + peaks);
                                    }
                                }
                                if (refinedPdbFileId != -1) {
                                    let index2FOFC_REFINE = mapFileNamesArr.indexOf("2FOFC_REFINE");
                                    let indexFOFC_REFINE = mapFileNamesArr.indexOf("FOFC_REFINE");
                                    if ((index2FOFC_REFINE == -1) || (indexFOFC_REFINE == -1)) {
                                        listUglyMol.push("");
                                    } else {
                                        var pdbUrl = downloadPhasingFilesByPhasingAttachmentId(this.props.user, this.props.proposal, refinedPdbFileId);
                                        var mapUrl1 = downloadPhasingFilesByPhasingAttachmentId(this.props.user, this.props.proposal, mapsArr[index2FOFC_REFINE]);
                                        var mapUrl2 = downloadPhasingFilesByPhasingAttachmentId(this.props.user, this.props.proposal, mapsArr[indexFOFC_REFINE]);
                                        var peaks = downloadPhasingFilesByPhasingAttachmentId(this.props.user, this.props.proposal, peaksFileId);
                                        listUglyMol.push('../viewer/uglymol/index.html?pdb=' + pdbUrl + '&map1=' + mapUrl1 + '&map2=' + mapUrl2 + '&peaks=' + peaks);
                                    }
                                }
                            }
                            /** It will add only the files coming from these steps */

                            toBePushed["downloadFilesUrl"] = getDownloadFilesByPhasingStepIdURL(_this.props.user, _this.props.proposal, parseDownloadAttachments(steps[z]));
                            if (listUglyMol.length == 0) {
                                listUglyMol.push("");
                                listUglyMol.push("");
                            }
                            toBePushed["listUglyMol"] = listUglyMol;
                            node["metrics"].push(toBePushed);
                        }
                    }
                    node["phasingStepId"] = steps[0].PhasingStep_phasingStepId;
                    return node;
                }

                /**
                 StepS for Phasing are: PREPARE,  SUBSTRUCTUREDETERMINATION, PHASING AND MODELBUILDING
                 StepS for Molecular replacement are: PHASING AND REFINEMENT */

                /** If there is model building then we will display modelbuilding */
                if (_.find(stepsBySpaceGroup, { "PhasingStep_phasingStepType": "MODELBUILDING" }) != null) {
                    node = getNodeByPhasingStep(node, stepsBySpaceGroup, "MODELBUILDING");
                }
                else {
                    if (_.find(stepsBySpaceGroup, { "PhasingStep_phasingStepType": "REFINEMENT" }) != null) {
                        node = getNodeByPhasingStep(node, stepsBySpaceGroup, "REFINEMENT");
                    }
                    else {
                        /** There is no model building the we parse the phasing*/
                        if (_.find(stepsBySpaceGroup, { "PhasingStep_phasingStepType": "PHASING" }) != null) {
                            node = getNodeByPhasingStep(node, stepsBySpaceGroup, "PHASING");
                        }
                        else {
                            if (_.find(stepsBySpaceGroup, { "PhasingStep_phasingStepType": "SUBSTRUCTUREDETERMINATION" }) != null) {
                                node = getNodeByPhasingStep(node, stepsBySpaceGroup, "SUBSTRUCTUREDETERMINATION");
                            }
                            else {
                                node = getNodeByPhasingStep(node, stepsBySpaceGroup, "PREPARE");
                            }
                        }
                    }
                }

                /** This will be used to sort */
                var count = 0;
                if (node.hasPrepare) {
                    count = count + 1;
                }
                if (node.hasSub) {
                    count = count + 1;
                }
                if (node.hasPhasing) {
                    count = count + 1;
                }
                if (node.hasModel) {
                    count = count + 1;
                }
                if (node.hasRefinement) {
                    count = count + 1;
                }

                node["count"] = count;
                parsed.push(node);
            }
        }

        parsed.sort(function (a, b) { return a.count < b.count; });
        /** Parsing the metrics */
        for (var i = 0; i < parsed.length; i++) {
            if (parsed[i]) {
                if (parsed[i].metrics) {
                    parsed[i].metrics.sort(function (a, b) {
                        try {
                            return parseFloat(b._CC_of_partial_model) - parseFloat(a._CC_of_partial_model);
                        }
                        catch (e) {
                            return false;
                        }
                    });
                }
            }
        }
        return parsed;
    }
}

PhasingDataCollectionGroup.propTypes = {
    user: PropTypes.object,
    proposal: PropTypes.string,
    dataCollectionGroupId: PropTypes.int

};


/**
 * This class displays a phasing result
 */
export class PhasingResult extends Component {
    getRow(key, value) {
        return <tr>
            <td className="parameterKey" >{key}</td>
            <td className="parameterValue" >{value}</td>
        </tr>;
    }
    getHeader(value) {
        return  <Grid fluid>
                <Row>
                    <Col sm={12} md={4}></Col> 
                    <Col sm={12} md={4}>
                        <Table>
                                <tbody>
                                    <tr>
                                        <td colspan="2">
                                            <h3>{value.spaceGroup}</h3>
                                        </td>
                                    </tr>
                                    {value.steps.map((phasingStep, index) => {                                        
                                        return <tr>
                                            <td>{phasingStep}</td>
                                            <td class="text-success" ><Glyphicon glyph="ok" /></td>
                                        </tr>
                                    })}
                                </tbody>
                        </Table>
                    </Col>
                    <Col sm={12} md={4}></Col>          
                 </Row>
        </Grid>;
    }
    render() {
        var value = this.props.result;
        return <div>
            {this.getHeader(value)}
            <br />
            <Grid fluid>
                {value.metrics.map((metric, index) => {
                    return <Row>
                        <Col sm={12} md={2}>
                            <Table>
                                <tbody>
                                    {this.getRow("Method", metric.PhasingStep_method )}
                                    {this.getRow("Program", <a href={metric.downloadFilesUrl} style={{pointer:'cursor' }} class="text-primary"> {metric.PhasingProgramRun_phasingPrograms} <Glyphicon glyph='download' ></Glyphicon></a>)}
                                    {this.getRow("Resolution", metric.PhasingStep_highRes + "-" + metric.PhasingStep_lowRes)}
                                    {this.getRow("Solvent content", metric.PhasingStep_solventContent)}
                                    {this.getRow("Chain Count", metric.Chain_Count)}
                                    {this.getRow("Residues Count", metric.Residues_Count)}
                                    {this.getRow("Average Fragment Length", convertToFixed(metric.Average_Fragment_Length, 2))}
                                    {this.getRow("CC of partial model", metric.CC_of_partial_model)}

                                </tbody>
                            </Table>

                        </Col>
                        <Col sm={12} md={2}>
                            <ImageZoom image={{ style: { width: '100%' }, src: metric.DSIGMA_RESOLUTION }} />
                        </Col>
                        <Col sm={12} md={2}>
                            <ImageZoom image={{ style: { width: '100%' }, src: metric.CCALL_CCWEAK }} />
                        </Col>
                        <Col sm={12} md={2}>
                            <ImageZoom image={{ style: { width: '100%' }, src: metric.CONTRAST_CYCLE }} />
                        </Col>
                        <Col sm={12} md={2}>
                            <ImageZoom image={{ style: { width: '100%' }, src: metric.CONTRAST_CYCLE }} />
                        </Col>
                        <Col sm={12} md={2}>
                            <ImageZoom image={{ style: { width: '100%' }, src: metric.pngURL }} />
                        </Col>
                    </Row>

                })
                }
            </Grid>
            })}
    </div>;
    }
}


// WEBPACK FOOTER //
// ./src/components/Mx/DataCollectionGroup/PhasingDataCollectionGroup/PhasingDataCollectionGroup.js